import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { defineComponent as _defineComponent } from 'vue';
import PanelHeader from '@/components/renewal/common/panel-header.vue';
import { ref, computed, onBeforeMount, onMounted, onBeforeUnmount, watch } from 'vue';
import { Container, Draggable } from 'vue-smooth-dnd';
import Icon from '@/components/renewal/common/icon.vue';
import { useTelemetry } from '@/plugins/telemetry';
import { useRepositories } from '@/plugins/repositories';
import { useToast } from '@/plugins/vueToast';
import { VTabsItems } from 'vuetify/lib';
export default /*#__PURE__*/_defineComponent({
  __name: 'news-panel',
  setup: function setup(__props) {
    var SCROLL_DISTANCE = 80;
    var MOBILE_WIDTH = 600;
    var content = ref(null);
    var isMobile = ref(false);
    var totalCountLoading = ref(false);
    var totalCount = ref(0);
    var countByCategoryLoading = ref(false);
    var countByCategory = ref([]);
    var activeCategoryName = ref(null);
    var categoriesLoading = ref(false);
    var categories = ref([]);
    var news = ref([]);
    var loading = ref(false);
    var telemetry = useTelemetry();
    var route = useRoute();
    var repositories = useRepositories();
    var toast = useToast();
    var directories = {
      'ファイナンス・ディスクロージャー': '1/45',
      'エネルギー・インフラ': '2/10',
      会社法: '3/11',
      危機管理: '4/12',
      'M&A': '5/13',
      倒産: '6/16',
      '一般民事・債権管理': '7/18',
      '国際訴訟・仲裁': '7/19',
      '競争法/独禁法': '8/20',
      消費者法: '8/21',
      労働法: '9/22',
      税務: '10/23',
      知的財産法: '11/24',
      '医事・薬事': '12/28',
      海事: '12/29',
      通商: '13/34',
      IT: '11/46',
      行政法: '14/47',
      刑事: '15/48'
    };
    var ADDITIONAL_NEWS_COUNT = 10;
    var MOBILE_LOAD_COUNT = 3;
    var DEFAULT_LOAD_COUNT = 5;
    var firstLoad = ref(true);
    var showLoadMore = computed(function () {
      var count = getCount(activeCategoryName.value);
      return (count !== null && count !== void 0 ? count : 0) > getNews.value.length && !loading.value;
    });
    var onClickLoadMore = function onClickLoadMore() {
      fetchAdditionalData(activeCategoryName.value);
    };
    var fetchTotalCount = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              totalCountLoading.value = true;
              _context.n = 1;
              return repositories.news.getNewsCount();
            case 1:
              totalCount.value = _context.v;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error(_t);
            case 3:
              _context.p = 3;
              totalCountLoading.value = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function fetchTotalCount() {
        return _ref.apply(this, arguments);
      };
    }();
    var fetchCountByCategory = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              countByCategoryLoading.value = true;
              _context2.n = 1;
              return repositories.news.getNewsCountByCategory();
            case 1:
              countByCategory.value = _context2.v;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error(_t2);
            case 3:
              _context2.p = 3;
              countByCategoryLoading.value = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2, 3, 4]]);
      }));
      return function fetchCountByCategory() {
        return _ref2.apply(this, arguments);
      };
    }();
    var getCount = function getCount(categoryName) {
      var _count$count;
      if (!categoryName) {
        return 0;
      }
      if (categoryName === '全て') {
        return totalCount.value;
      }
      var count = countByCategory.value.find(function (c) {
        return c.key == categoryName;
      });
      return (_count$count = count === null || count === void 0 ? void 0 : count.count) !== null && _count$count !== void 0 ? _count$count : null;
    };
    var fetchCategories = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var response, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              categoriesLoading.value = true;
              _context3.n = 1;
              return repositories.users.getUserNewsCategories();
            case 1:
              response = _context3.v;
              categories.value = response.newsCategories;
              activeCategoryName.value = categories.value[0].name;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              toast.error('ニュースカテゴリの取得に失敗しました');
              return _context3.a(2);
            case 3:
              categoriesLoading.value = false;
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      return function fetchCategories() {
        return _ref3.apply(this, arguments);
      };
    }();
    var updateHeight = function updateHeight() {
      var _content$value;
      var contentElement = (_content$value = content.value) === null || _content$value === void 0 ? void 0 : _content$value.$el;
      if (contentElement && firstLoad.value) {
        // contentElement.offsetHeightがcontentの高さとして正しく計算されるように一度autoに設定する
        contentElement.style.setProperty('--content-height', 'auto');
        contentElement.style.setProperty('--content-height', "".concat(contentElement.offsetHeight, "px"));
      }
    };
    watch(activeCategoryName, function (newVal) {
      fetchData(newVal);
    });
    watch(isMobile, function () {
      nextTick(function () {
        return updateHeight();
      });
    });
    var fetchData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(categoryName) {
        var category, categoryId, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              category = categories.value.find(function (c) {
                return c.name === categoryName;
              });
              if (category) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              loading.value = true;
              firstLoad.value = true;
              news.value = [];
              categoryId = category.id;
              if (category.name === '全て') {
                categoryId = undefined;
              }
              _context4.p = 2;
              _context4.n = 3;
              return repositories.news.getNews(categoryId);
            case 3:
              news.value = _context4.v;
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t4 = _context4.v;
              toast.error('ニュースの取得に失敗しました');
              return _context4.a(2);
            case 5:
              loading.value = false;
              nextTick(updateHeight);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, null, [[2, 4]]);
      }));
      return function fetchData(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    var scrollContentDown = function scrollContentDown() {
      var _content$value2;
      var contentElement = (_content$value2 = content.value) === null || _content$value2 === void 0 ? void 0 : _content$value2.$el;
      if (contentElement) {
        contentElement.scrollTo({
          top: SCROLL_DISTANCE,
          behavior: 'smooth'
        });
      }
    };
    var fetchAdditionalData = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(categoryName) {
        var category, categoryId, _news$value, additionalNews, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              category = categories.value.find(function (c) {
                return c.name === categoryName;
              });
              if (category) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              loading.value = true;
              if (firstLoad.value) {
                nextTick(scrollContentDown);
              }
              firstLoad.value = false;
              categoryId = category.id;
              if (category.name === '全て') {
                categoryId = undefined;
              }
              _context5.p = 2;
              _context5.n = 3;
              return repositories.news.getNews(categoryId, news.value.length, ADDITIONAL_NEWS_COUNT);
            case 3:
              additionalNews = _context5.v;
              (_news$value = news.value).push.apply(_news$value, _toConsumableArray(additionalNews));
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t5 = _context5.v;
              toast.error('ニュースの取得に失敗しました');
              return _context5.a(2);
            case 5:
              loading.value = false;
            case 6:
              return _context5.a(2);
          }
        }, _callee5, null, [[2, 4]]);
      }));
      return function fetchAdditionalData(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    var isDragging = false;
    var clickedCategoryName = null;
    var onMouseDown = function onMouseDown(categoryName) {
      isDragging = false;
      clickedCategoryName = categoryName;
    };
    var onMouseUp = function onMouseUp(event) {
      if (!isDragging && clickedCategoryName) {
        activeCategoryName.value = clickedCategoryName;
      }
      clickedCategoryName = null;
    };
    var onTabClick = function onTabClick(categoryName) {
      telemetry.sendClickTelemetry({
        button: 'news__tab',
        params: {
          categoryName: categoryName
        }
      }, route);
      if (!isDragging) {
        activeCategoryName.value = categoryName;
        updateActiveTabClass();
      }
    };
    var onClickHeadline = function onClickHeadline(headline, uri) {
      telemetry.sendClickTelemetry({
        button: 'news__headline',
        params: {
          headline: headline,
          uri: uri
        }
      }, route);
    };
    var onClickCategory = function onClickCategory(categoryName) {
      telemetry.sendClickTelemetry({
        button: 'news__category',
        params: {
          categoryName: categoryName
        }
      }, route);
    };
    var getGhostParent = function getGhostParent() {
      // ドラッグ可能な項目の親要素をposition: absoluteなどで位置を調整してしまうとドラッグオブジェクトの位置がズレる
      // 明示的にbodyを指定することで、ドラッグオブジェクトの位置がズレないようにする
      // https://github.com/kutlugsahin/vue-smooth-dnd?tab=readme-ov-file#get-ghost-parent
      return document.body;
    };
    var getNews = computed(function () {
      if (isMobile.value && firstLoad.value) {
        // モバイルでもっと見るボタンを押していない時は、最新の3件のみ表示
        return news.value.slice(0, MOBILE_LOAD_COUNT);
      }
      return news.value;
    });
    var skeltonCount = computed(function () {
      if (!firstLoad.value) {
        return ADDITIONAL_NEWS_COUNT;
      }
      if (isMobile.value) {
        return MOBILE_LOAD_COUNT;
      } else {
        return DEFAULT_LOAD_COUNT;
      }
    });
    var onDrop = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dropResult) {
        var addedIndex, removedIndex, category, insertIndex, _category, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              addedIndex = dropResult.addedIndex, removedIndex = dropResult.removedIndex;
              category = categories.value.splice(removedIndex, 1)[0];
              categories.value.splice(addedIndex, 0, category);
              updateActiveTabClass();
              insertIndex = addedIndex < removedIndex ? addedIndex : addedIndex + 1;
              _context6.p = 1;
              _context6.n = 2;
              return repositories.users.putUserNewsCategories(category.id.toString(), insertIndex);
            case 2:
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t6 = _context6.v;
              toast.error('ニュースカテゴリの並び替えに失敗しました');
              // 元に戻す
              _category = categories.value.splice(addedIndex, 1)[0];
              categories.value.splice(removedIndex, 0, _category);
              updateActiveTabClass();
              return _context6.a(2);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, null, [[1, 3]]);
      }));
      return function onDrop(_x3) {
        return _ref6.apply(this, arguments);
      };
    }();
    var onDragStart = function onDragStart() {
      isDragging = true;
    };
    var onResize = function onResize() {
      isMobile.value = window.innerWidth < MOBILE_WIDTH;
    };
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            fetchTotalCount();
            fetchCountByCategory();

            // activeCategoryName.valueが必要なので、fetchCategoriesを先に実行し、かつawaitで待つ
            _context7.n = 1;
            return fetchCategories();
          case 1:
            fetchData(activeCategoryName.value);
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    })));
    onMounted(function () {
      // ドラッグ中にマウスアップイベントが発生しないため、windowにマウスアップイベントを設定
      window.addEventListener('mouseup', onMouseUp);
      // ニュースのコンテンツ表示数が600pxを境に変わるので、resizeイベントを監視する
      onResize();
      window.addEventListener('resize', onResize);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('resize', onResize);
    });
    var updateActiveTabClass = function updateActiveTabClass() {
      // DnDとクリックの結果とactiveTabが正しく同期せず、activeTabの位置がずれる
      // FIXME: DOM操作でactiveTabの位置を修正
      var currentActiveTabIndex = categories.value.findIndex(function (c) {
        return c.name === activeCategoryName.value;
      });
      if (currentActiveTabIndex === -1) {
        return;
      }
      var allTabElements = document.querySelectorAll('.v-tabs-bar__content [role="tab"]');
      allTabElements.forEach(function (tab) {
        return tab.classList.remove('v-tab--active');
      });
      var activeTabElement = allTabElements[currentActiveTabIndex];
      if (activeTabElement) {
        activeTabElement.classList.add('v-tab--active');
      }
    };
    return {
      __sfc: true,
      SCROLL_DISTANCE: SCROLL_DISTANCE,
      MOBILE_WIDTH: MOBILE_WIDTH,
      content: content,
      isMobile: isMobile,
      totalCountLoading: totalCountLoading,
      totalCount: totalCount,
      countByCategoryLoading: countByCategoryLoading,
      countByCategory: countByCategory,
      activeCategoryName: activeCategoryName,
      categoriesLoading: categoriesLoading,
      categories: categories,
      news: news,
      loading: loading,
      telemetry: telemetry,
      route: route,
      repositories: repositories,
      toast: toast,
      directories: directories,
      ADDITIONAL_NEWS_COUNT: ADDITIONAL_NEWS_COUNT,
      MOBILE_LOAD_COUNT: MOBILE_LOAD_COUNT,
      DEFAULT_LOAD_COUNT: DEFAULT_LOAD_COUNT,
      firstLoad: firstLoad,
      showLoadMore: showLoadMore,
      onClickLoadMore: onClickLoadMore,
      fetchTotalCount: fetchTotalCount,
      fetchCountByCategory: fetchCountByCategory,
      getCount: getCount,
      fetchCategories: fetchCategories,
      updateHeight: updateHeight,
      fetchData: fetchData,
      scrollContentDown: scrollContentDown,
      fetchAdditionalData: fetchAdditionalData,
      isDragging: isDragging,
      clickedCategoryName: clickedCategoryName,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      onTabClick: onTabClick,
      onClickHeadline: onClickHeadline,
      onClickCategory: onClickCategory,
      getGhostParent: getGhostParent,
      getNews: getNews,
      skeltonCount: skeltonCount,
      onDrop: onDrop,
      onDragStart: onDragStart,
      onResize: onResize,
      updateActiveTabClass: updateActiveTabClass,
      PanelHeader: PanelHeader,
      Container: Container,
      Draggable: Draggable,
      Icon: Icon,
      VTabsItems: VTabsItems
    };
  }
});